export default {
  title: 'SEO',
  subtitle:
    'Muokkaa otsikkoa ja kuvausta, jotka näkyvät Googlen hakutuloksissa ja sosiaalisen median esikatseluissa. Jätä tyhjäksi käyttääksesi oletusarvoja.',
  fields: {
    title: {
      label: 'Sivun otsikko',
      placeholder: 'esim. Forza Napoli — aitoa napolilaista pizzaa Münchenissä',
      help: 'Näkyy otsikkona Googlen hakutuloksissa ja selaimen välilehdissä. Enintään 255 merkkiä; tavoittele 50–60 merkkiä parhaan esikatselun saamiseksi.',
    },
    description: {
      label: 'Meta-kuvaus',
      placeholder: 'Lyhyt kuvaus ravintolastasi, joka näkyy otsikon alla hakutuloksissa.',
      help: 'Enintään 500 merkkiä; Google näyttää tyypillisesti 150–160 merkkiä. Korosta sitä, mikä tekee ravintolastasi ainutlaatuisen.',
    },
  },
  buttons: {
    save: 'Tallenna',
  },
  toasts: {
    saved: 'SEO-asetukset tallennettu',
    failed: 'SEO-asetusten tallennus epäonnistui',
  },
};
